import 'css-chunk:src/components/form-fields/chip-holder-component/chip-holder-component.module.scss';export default {
  "chip-holder-component": "chip-holder-component_chip-holder-component__U2N0U",
  "disabled": "chip-holder-component_disabled__8KBra",
  "input-container": "chip-holder-component_input-container__OOCXf",
  "text": "chip-holder-component_text__Dc1vU",
  "white": "chip-holder-component_white__xTt0d",
  "grey": "chip-holder-component_grey__Zf0c4",
  "chip-holder": "chip-holder-component_chip-holder__wC-rz",
  "hidden": "chip-holder-component_hidden__Wa2Jx",
  "error-text": "chip-holder-component_error-text__nILlo"
};